import type { AnyAction, Dispatch } from '@reduxjs/toolkit';

type StoreAccessorState = {
  auth: {
    accessToken: string | null;
  };
  tenantAuth: {
    accessToken: string | null;
  };
  scope: {
    scope: 'lessor' | 'tenant';
  };
};

type StoreAccessor = {
  dispatch: Dispatch<AnyAction>;
  getState: () => StoreAccessorState;
};

let storeAccessor: StoreAccessor | null = null;

export const setStoreAccessor = (store: StoreAccessor) => {
  storeAccessor = store;
};

export const dispatchStoreAction = (action: AnyAction) => {
  if (!storeAccessor) return;

  storeAccessor.dispatch(action);
};

export const getStoreState = () => {
  return storeAccessor?.getState();
};
